import React from "react";
import { Helmet } from "react-helmet-async";
import seoData from './../Seo/seoData.json'

const SeoHelmet = ({ page }) => {
  const { title, description, keywords } = seoData[page] || {};

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
    </Helmet>
  );
};

export default SeoHelmet;
